import selectCalendarSurfaceAddinsOption from '../actions/selectCalendarSurfaceAddinsOption';
import CalendarSurfaceAddinsOptionState from '../store/schema/CalendarSurfaceAddinsOptionState';
import store from '../store/store';
import { AddinCommandSurfaceItem, ExtensibilityModeEnum } from 'owa-addins-types';
import { getFallbackValueIfNull } from 'owa-options-core';
import { ActionKey } from 'owa-outlook-service-options';
import { getOptionsForFeature, OwsOptionsFeatureType } from 'owa-outlook-service-options';
import { CalendarSurfaceAddinsOptions } from 'owa-outlook-service-options';
import strings from 'owa-strings/owa-options-strings';
import { getAddinOptionSurfaceItems } from 'owa-surface-actions';
import SurfaceActionsShared from 'owa-surface-actions-view/lib/components/SurfaceActionsShared';
import { SurfaceActionIcon } from 'owa-surface-actions/lib/utils/getIconNameFromKey';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';

const ABSTRACT_CALENDAR_SVG = require('./svg/abstractCalendar.svg');
const MAX_PREVIEW_ITEM_COUNT = 7;

let styles = require('./CalendarSurfaceAddins.scss');

export interface CalendarSurfaceAddinsProps {
    optionStore?: CalendarSurfaceAddinsOptionState;
    userOptions?: CalendarSurfaceAddinsOptions;
}

@reactive({
    optionStore: () => store,
    userOptions: () =>
        getOptionsForFeature<CalendarSurfaceAddinsOptions>(
            OwsOptionsFeatureType.CalendarSurfaceAddins
        ),
})
export default class CalendarSurfaceAddins extends React.Component<CalendarSurfaceAddinsProps, {}> {
    render() {
        let { optionStore, userOptions } = this.props;

        // Static actions are not configurable at the moment.
        let actions: ActionKey[] = [];
        let selectedActions: string[] = [];
        let actionDisplayNameGetter: (key: ActionKey) => string;
        let actionIconNameGetter: (key: ActionKey) => SurfaceActionIcon;
        let onActionSelected: (
            actionCollection: string[],
            actionKey: string,
            isSelected: boolean
        ) => void;

        // Get the organizer and attendee collections.
        let organizerAddinCollection = getAddinOptionSurfaceItems(
            ExtensibilityModeEnum.AppointmentOrganizer
        );
        let attendeeAddinCollection = getAddinOptionSurfaceItems(
            ExtensibilityModeEnum.AppointmentAttendee
        );

        // Pull the actual add-ins from the organizer collection, concat the attendee add-ins, and de-dupe based on key.
        // Since the de-duping logic will keep the first instance of duplicates and we want "Get Add-ins" to be the last entry in the shared list,
        // we'll reverse both collections before merging, and then reverse again at the end.
        let addins: AddinCommandSurfaceItem[] = organizerAddinCollection
            ? organizerAddinCollection.slice().reverse()
            : [];
        addins = addins.concat(
            attendeeAddinCollection ? attendeeAddinCollection.slice().reverse() : []
        );
        addins = addins
            .filter((addin, index, addins) => {
                return addins.map(mappedAddin => mappedAddin.key).indexOf(addin.key) === index;
            })
            .reverse();

        // Get the selected ("pinned") addins from the user's options
        let selectedAddins = getFallbackValueIfNull(
            optionStore.calendarSurfaceAddins,
            userOptions.calendarSurfaceAddins
        ).slice();

        let onAddinSelected = (
            addinCollection: string[],
            addinKey: string,
            isSelected: boolean
        ) => {
            selectCalendarSurfaceAddinsOption(addinCollection, addinKey, isSelected);
        };

        return (
            <div>
                <SurfaceActionsShared
                    actions={actions}
                    addins={addins}
                    selectedActions={selectedActions}
                    selectedAddins={selectedAddins}
                    onActionSelected={onActionSelected}
                    onAddinSelected={onAddinSelected}
                    getDisplayNameFromAction={actionDisplayNameGetter}
                    getIconNameFromAction={actionIconNameGetter}
                    isLeftToRight={true}
                    previewImageUri={ABSTRACT_CALENDAR_SVG}
                    previewClassName={styles.calendarCommandBarPreview}
                    maxPreviewItemCount={MAX_PREVIEW_ITEM_COUNT}
                    description={strings.options_calendarSurfaceAddins_description}
                />
            </div>
        );
    }
}
